import { TeamReportDataTableRow } from "../TeamReportDataTable/types";

export const getTableData = (rows: TeamReportDataTableRow[]) => {
  return rows
    .filter((row) => row.name !== "Overall")
    .map((row) => {
      const possCell = row.cells["Poss"];
      const pppCell = row.cells["PPP"];

      return {
        rowType: String(row.name),
        Poss: possCell?.value || 0,
        ppp: pppCell?.value || 0,
        pppPercentile: pppCell?.percentile || 0,
        pppRank: pppCell?.rank || 0,
      };
    })
    .sort((a, b) => a.Poss - b.Poss);
};
